module.exports = __webpack_public_path__ + "static/mission-img_2-bc04a9eac06967090bde8f4e7ab62243.png";